// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> price-brothers-preferred -> waterford-place-apartments-townhomes
// Generated: 2026-11-04T18:28:14.394Z
// Counts: 2 design, 93 content, 16 slot group, 5 collection binding, 6 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Outdoor Spaces, In-Home Features and Professional Services</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Connect With Our </h2><h2>Overland Park Leasing Team</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently Asked Questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find the Waterford Place Apartments &amp; Townhomes Floor Plan for You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments and Townhomes in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to Waterford Place Apartments &amp; Townhomes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Perfectly Located in Overland Park, Kansas</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Overland Park, KS Near Waterford Place Apartments &amp; Townhomes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pets Are Welcome at Waterford Place Apartments &amp; Townhomes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Tour Waterford Place Apartments &amp; Townhomes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Virtual Tours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "accessibilityhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Our commitment to accessible living at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Community Amenities at Waterford Place Apartments &amp; Townhomes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Begin your application for <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Waterford Place Apartments &amp; Townhomes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Quick answers about leasing, amenities, and life at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>1 and 2 Bedroom Apartments and Townhomes in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_floorplans_blurb"
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Waterford Place Apartments &amp; Townhomes Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>See Apartments, Townhomes and Amenities in Overland Park, KS</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover modern living at Eastpark with in-unit laundry. Enjoy ultimate convenience in Denton, TX, where comfort meets stylish amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Denton, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Discover the neighborhood surrounding <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments Near Corporate Woods in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "onebedroomhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>1 Bedrooms</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-Friendly Apartments and Townhomes in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.benefits_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Program Benefits</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.callout_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.callout_title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive Savings for Local Professionals at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.footnote": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Preferred Employer Partners</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>How <span data-type=\"field-token\" data-field=\"property_name\"></span> collects, uses, and protects your information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccesshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident portal login and account tools for <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>What residents are saying about living at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule an Apartment Tour in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore nearby communities from Price Brothers Management Co. — each with its own character, amenities, and floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sisterpropertieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sisterpropertieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Browse all pages on the <span data-type=\"field-token\" data-field=\"property_name\"></span> website</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "studioshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Studio Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "studioshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Studios</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank you for reaching out to <span data-type=\"field-token\" data-field=\"property_name\"></span>—we will be in touch soon</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "townhomes-floor-plans.empty_message": {
    "overrideType": "VALUE",
    "customValue": "<p>There are no townhomes listed right now. Explore all of our floor plans or contact us for upcoming availability.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Walk through <span data-type=\"field-token\" data-field=\"property_name\"></span> from anywhere before you visit <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.employers": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Active Military</p></li><li><p>Black &amp; Veatch</p></li><li><p>City of Overland Park</p></li><li><p>Garmin</p></li><li><p>HCA Hospitals</p></li><li><p>Kiewit</p></li><li><p>Price Brothers Commercial Tenants</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "featuredfloorplan.view_all_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      },
      "url": {
        "type": "VALUE",
        "customValue": ""
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "preferredemployercta.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      }
    }
  },
  "floorplanslist.bg_pattern": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a1a7d0-7438-720b-9b8f-0642ef94045a.webp"
      },
      "tile_size": {
        "type": "VALUE",
        "customValue": "1000"
      },
      "overlay_opacity": {
        "type": "VALUE",
        "customValue": "90"
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-2aeb-72db-acd6-a17d24fee125.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-5027-702a-98c7-c596991dbd9e.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-6645-74cb-8eaa-e3c353563192.webp"
      }
    }
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Claremont Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "11909 W. 109th Street, Overland Park, KS 66210"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=11909+W.+109th+Street,+Overland+Park,+KS+66210"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.claremontaptskc.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-f8cb-74e9-a385-9403c8c0696c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A well-decorated communal lounge area with a fireplace, comfortable seating, and large windows."
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Crowne Chase Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "11621 W. 118th Terrace, Overland Park, KS 66210"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=11621+W.+118th+Terrace,+Overland+Park,+KS+66210"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.crownechase.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-eb09-769c-8cfa-de66343b6b36.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of multifamily apartment building with a picnic table and lush green lawn."
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Creekside Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "11920 Oakmont St, Overland Park, KS 66213"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=11920+Oakmont+St,+Overland+Park,+KS+66213"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.creeksideaptskc.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-f91c-765b-8068-b2c7832936c0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and umbrellas."
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Stonebriar Woods Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "12401 W. 120th St, Overland Park, KS 66213"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=12401+W.+120th+St,+Overland+Park,+KS+66213"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.stonebriarwoods.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-c894-731b-9794-a25a986bc4da.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and kitchen area with white cabinets and stainless steel appliances."
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Stonebriar Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "12490 Quivira Rd, Overland Park, KS 66213"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=12490+Quivira+Rd,+Overland+Park,+KS+66213"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.stonebriarkc.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-cb69-73ec-bd71-1b405486bc8c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool area with lounge chairs, a fountain, and apartment buildings in the background."
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Highland Park Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "10334 Goddard, Overland Park, KS 66214"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=10334+Goddard,+Overland+Park,+KS+66214"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.highlandparkaptskc.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-e50c-77ee-8e1d-5a44ac575432.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxury apartment complex swimming pool and clubhouse exterior at dusk."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": [
      "ec_da6dd782be9407ae714c3740",
      "ec_e5896562866ab30ded39df67",
      "ec_b600a9c57f27d6b43bfdbb41",
      "ec_d8fa59d2c65a3f709f24e044",
      "ec_da9d9045cf0e9c6bf88f41a1",
      "ec_bfcff1eeab1d1390b4265c3b",
      "ec_68fa7a65abf1c47f3fadc0e0",
      "ec_8006bd401c9304e7f64d406c",
      "ec_f27914db31502e0895f6eaf0",
      "ec_df9452f932583a7f99daa87f",
      "ec_01c5ab1bff4636491741513b",
      "ec_21b4b15f46bbbf36b54a9c1b",
      "ec_0cc01b784c75b9a431547f5d",
      "ec_7bd0521e0f186bf0cff5aea8",
      "ec_973209f93a88ec6a291adcf8",
      "ec_8e3af82b5d4bf6c04ea5fddf",
      "ec_942da20b8fa1a20600d0ef5c",
      "ec_829b58071502cbbc210af5b6",
      "ec_b951ed04dafd26e8d8d07160",
      "ec_f4e7925752e86c82018d7146"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_d8fa59d2c65a3f709f24e044",
      "ec_df9452f932583a7f99daa87f",
      "ec_b600a9c57f27d6b43bfdbb41",
      "ec_8006bd401c9304e7f64d406c",
      "ec_f27914db31502e0895f6eaf0",
      "ec_f4e7925752e86c82018d7146",
      "ec_21b4b15f46bbbf36b54a9c1b",
      "ec_68fa7a65abf1c47f3fadc0e0",
      "ec_bfcff1eeab1d1390b4265c3b",
      "ec_da9d9045cf0e9c6bf88f41a1",
      "ec_e5896562866ab30ded39df67",
      "ec_8e3af82b5d4bf6c04ea5fddf",
      "ec_01c5ab1bff4636491741513b",
      "ec_0cc01b784c75b9a431547f5d",
      "ec_7bd0521e0f186bf0cff5aea8",
      "ec_da6dd782be9407ae714c3740",
      "ec_973209f93a88ec6a291adcf8",
      "ec_942da20b8fa1a20600d0ef5c",
      "ec_829b58071502cbbc210af5b6",
      "ec_b951ed04dafd26e8d8d07160"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": [
      "ec_b0e38e1dc797fded85763f2e",
      "ec_338f207e3759022116c6e549",
      "ec_3929a325467181b27109294d",
      "ec_8a93e8ec5a1399d3592b3c1d",
      "ec_5bb8327d4792a3a9e3ec6e97",
      "ec_64068cd92596308667f13fa3",
      "ec_6bc2bb7bff07444412c91e23",
      "ec_2a559be33ee54766dfde9029",
      "ec_9ab44e30141d746f5aa08d24",
      "ec_b878bafb81a5fb1d99676b61",
      "ec_2d2fdd71a7ee48056470563c",
      "ec_9ede9285d78ccba00963751b",
      "ec_b3f05ee326c6209da9858c5b",
      "ec_e6e1524740a83abc037e8243",
      "ec_4a26bb8159c295a9f8f473b1",
      "ec_2ed11e76d9b6e6c9f4316f12"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync-map",
      "position": 7
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  }
};
